/**
 * The example prompt on the prompt page. It is the "morning research brief" from the
 * landing page, written so it succeeds with public web access only: no account,
 * no login, and no schedule gate, so it runs on demand the first time.
 */
export const EXAMPLE_PROMPT = `Write me a research brief on new work in robotics. Run it whenever I ask; do not skip it because of the day or the time.

Check these three public sources. None of them needs an account.
1. arXiv (arxiv.org): new papers in cs.RO, plus cs.LG papers that are about robots. Use the public listing and search pages.
2. Lab and company blogs: the public research and news pages of at least five robotics labs or companies (for example Boston Dynamics, Figure, 1X, Physical Intelligence, DeepMind Robotics, Toyota Research Institute, and university robotics labs).
3. News: a Google News search for "robotics" and one for "robot learning".

Rules:
- Only include work published in the last 7 days. Skip anything older, even if it is trending.
- Every finding needs a primary source: the paper, the lab's own post, or the company's own announcement. A repost or a news summary is not enough on its own; find the original and link it.
- Use only pages you can open without logging in. If a page will not load, note it and move on; it is not a failure.
- Group the findings: papers, demos and products, and everything else.
- For each finding write two or three sentences: what it is, why it matters, and the link.
- If you find fewer than three items, say so instead of padding the list.

Output:
Write the brief to a Markdown file named brief.md with today's date as the title.
Put the most important finding first.`;
